<template>
    <div>
        <div v-bind:key="idx" v-for="(post, idx) in posts"
             v-bind:style="{'background-image': 'url(' + post.imageUrl + ')'}" class="instagram-image-container"
        >
            <div class="overlay" v-on:click="openModal(idx)">
                <div class="likes-container">
                    <div class="pointer-devices">
                        <img src="https://icon-library.net/images/white-heart-icon-png/white-heart-icon-png-11.jpg" class="likes-image leaves">{{post.likes}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import StatsService from "../Services/StatsService";

    export default {
        name: 'InstagramWidget',
        props: ['data', 'widgetId'],
        data: function() {
            return {
                posts: [],
                settings: {}
            }
        },
        methods: {
            openModal(postId) {
                const urlParams = new URLSearchParams(window.location.search);
                const iframeID = urlParams.get('iframeID');

                window.top.postMessage({event: 'openModal', id: iframeID + '-modal', postId}, "*")
            }
        },
        async mounted() {

            const urlParams = new URLSearchParams(window.location.search);
            const iframeID = urlParams.get('iframeID');

            window.top.postMessage({event: 'updateHeight', scrollHeight: document.body.scrollHeight, id: iframeID}, "*")
            setInterval(function () {
                // first parameter is the message to be passed
                // second paramter is the domain of the parent
                // in this case "*" has been used for demo sake (denoting no preference)
                // in production always pass the target domain for which the message is intended
                window.top.postMessage({event: 'updateHeight', scrollHeight: document.body.scrollHeight, id: iframeID}, "*")
            }, 100);
            this.posts = this.data.posts
            this.settings = this.data.settings
            try {
                await StatsService.widgetViewed({widgetId: this.widgetId})
            } catch (e) {
                // Tracking failures should not affect widget rendering.
            }

            try {
                const localStorageKey = 'guestflip_widget_' + this.widgetId + '_viewed'
                if(localStorage.getItem(localStorageKey) == null) {
                    localStorage.setItem(localStorageKey, true)
                    await StatsService.widgetVisited({widgetId: this.widgetId})
                }
            } catch (e) {
                // Tracking failures should not affect widget rendering.
            }

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .title {
        width: 100%;
        font-size: 30px;
        margin: 15px 0;
    }

    .instagram-image-container {
        position: relative;
        display: inline-flex;
        width: 25%;
        margin: 0 0%;
        padding-top: 25%;
        background-size: cover;
        background-position: center;
    }

    .instagram-image-container > img {
        max-width: 100%;
        height: auto;
    }

    .instagram-image-container .overlay {
        cursor: pointer;
        display: flex;
        position: absolute;
        opacity: 0;
        color: white;
        font-size: 30px;
        align-items: center;
        justify-content: center;
        left:0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 10000;
    }

    .instagram-image-container .overlay .likes-image {
        width:50px;
        padding-right: 10px;
    }
    .instagram-image-container .overlay:hover {
        opacity: 1;
    }

    .instagram-image-container .overlay:after {
        content: '';
        position: absolute;
        left:0;
        top: 0;
        width: 100%;
        height: 100%;
        background: black;
        opacity: 0.75;
        z-index: -1;
    }

    .instagram-image-container .overlay .likes-container {
        display: flex;
        align-items: center;
        justify-items: center;
    }

    @media screen and (max-width: 992px) {
        .instagram-image-container {
            width: 50%;
            padding-top: 50%;
        }
    }

    @media screen and (max-width: 400px) {
        .instagram-image-container {
            width: 100%;
            padding-top: 100%;
        }
    }

</style>
